<template>
    <transition appear enter-active-class="animated bounceInRight">
        <f7-view main>
            <f7-page>
                <!-- header -->
                <cm-navbar :title="$ml.get('checkFormula')">
                    <f7-nav-right><f7-link @click="check">{{ $ml.get('check') }}</f7-link></f7-nav-right>
                </cm-navbar>
                <!-- END header -->

                <!-- body -->
                <f7-list inline-labels no-hairlines-md>
                    <f7-list-item :title="$ml.get('finishedProducts')" smart-select :smart-select-params="{openIn: 'page', closeOnSelect: false, searchbar: true}">
                        <select name="material_id" v-model="material_id">
                            <option v-for="item in materials1" :value="item.id" :key="item.id">[{{ item.materialtype.name }}] {{ item.name }}</option>
                        </select>
                    </f7-list-item>
                </f7-list>

                <div v-if="detail">
                    <f7-block-title>{{ $ml.get('formulaDetail') }}: {{ detail[0].formula_code }}</f7-block-title>
                    <f7-card class="demo-card-header-pic">
                        <f7-card-content>
                            <ul><li v-for="item in detail" :key="item.id">{{ item.percent }} % {{ item.material.name }}</li></ul>
                        </f7-card-content>
                        <f7-card-footer v-if="canEdit">
                            <f7-link></f7-link><f7-link @click="openPopup">{{ $ml.get('editFormula') }}</f7-link>
                        </f7-card-footer>
                    </f7-card>
                </div>
                <!-- END body -->

                <f7-popup class="demo-popup" :opened="popupOpened" @popup:closed="closePopup">
                    <f7-view>
                        <f7-page>
                            <f7-navbar :title="$ml.get('editFormula')">
                                <f7-nav-right>
                                    <f7-link popup-close>{{ $ml.get('close') }}</f7-link>
                                </f7-nav-right>
                            </f7-navbar><br>

                            <div v-for="(item, index) in cloneDetail" :key="'detail' + index">
                                <f7-block-title v-show="index > 0"><f7-link @click="remove(index)"><i class="f7-icons">delete</i></f7-link></f7-block-title>

                                <f7-list inline-labels no-hairlines-md>
                                    <f7-list-item :title="$ml.get('riceAndSuppliment')" smart-select :smart-select-params="{openIn: 'page', closeOnSelect: true, searchbar: true}">
                                        <select :name="'material_id' + item.material_id" v-model="item.material_id" v-validate="'required'">
                                            <option v-for="material in materials2" :value="material.id" :key="material.id">[{{ material.materialtype.name }}] {{ material.name }}</option>
                                        </select>
                                    </f7-list-item>
                                    <f7-list-input type="number" :label="$ml.get('amount')" placeholder="0" clear-button :value="item.percent" @input="item.percent = $event.target.value" :name="'amount' + item.id" v-validate="'required'"></f7-list-input>
                                </f7-list>
                            </div>

                            <f7-block>
                                <f7-row>
                                    <f7-col>
                                        <f7-button round fill @click="addMore">
                                            <i class="f7-icons">add</i>
                                        </f7-button>
                                    </f7-col>
                                    <f7-col>
                                        <f7-button round fill @click="updateFormulaDetail">
                                            <i class="f7-icons" style="font-size: 24px; line-height: inherit">save</i>
                                        </f7-button>
                                    </f7-col>
                                </f7-row>
                            </f7-block>
                        </f7-page>
                    </f7-view>
                </f7-popup>
            </f7-page>
        </f7-view>
    </transition>
</template>

<script>
    import CMNavbar from './Navbar'
    import Query    from '@/services/api/Query'
    import Mutation from '@/services/api/Mutation'

    export default {
        name: 'CheckFormula',
        props: {},
        components: {
            'cm-navbar': CMNavbar,
        },
        data() {
            return {
                material_id: null,
                detail:      null,
                cloneDetail: null,
                canEdit:     false,
                popupOpened: false,
                materials1:   [],
                materials2:   [],
            }
        },
        methods: {
            async check() {
                if (! this.material_id)
                    return this.$f7.dialog.alert(this.$ml.get('errors.requiredAll'), this.$ml.get('errors.title'))

                this.$f7.dialog.preloader(this.$ml.get('processing'))
                this.detail = this.$helper.data(await Query.withFormulaDetails(this.material_id).get(), 'formula_details')
                this.$f7.dialog.close()

                if (! this.detail)
                    return this.$f7.dialog.alert(this.$ml.get('msg.noFormulaDetails'), this.$ml.get('information'))
            },

            async openPopup() {
                this.$f7.dialog.preloader(this.$ml.get('processing'))
                let detail = this.$helper.data(await Query.withFormulaDetails(this.material_id).get(), 'formula_details')
                this.cloneDetail = detail
                this.popupOpened = true
                this.$f7.dialog.close()
            },

            closePopup() {
                this.popupOpened = false
                this.cloneDetail = []
            },

            remove(index) {
                this.cloneDetail.splice(index, 1)
            },

            addMore() {
                this.cloneDetail.push({
                    'material_id': null,
                    'percent': null,
                })
            },

            async updateFormulaDetail() {
                if (! await this.$validator.validateAll())
                    return this.$f7.dialog.alert(this.$ml.get('errors.requiredAll'), this.$ml.get('errors.title'))

                this.$f7.dialog.preloader(this.$ml.get('processing'))
                let details = this.cloneDetail.map((item) => {
                    return {
                        'material_id': item.material_id,
                        'percent': item.percent,
                    }
                })
                let params  = {'formula_id': this.cloneDetail[0].formula_id, 'formulaDetails': this.$helper.toString(details)}
                let result  = await Mutation.editFormulaDetail(params).execute()

                if (result.data.errors) {
                    let message = this.$helper.errors(result.data.errors)
                    this.$f7.dialog.close()

                    return this.$f7.dialog.alert(message, this.$ml.get('errors.title'))
                }

                this.detail = this.$helper.data(result, 'edit_formula_detail')
                this.$f7.dialog.close()
                this.closePopup()
            },
        },

        async created() {
            let formData1   = await Query.withMaterials('all', true).get()
            this.materials1 = this.$helper.data(formData1, 'materials')

            let formData2   = await Query.withMaterials('LNLBTP,LNLPP').get()
            this.materials2 = this.$helper.data(formData2, 'materials')

            let permissions = JSON.parse(localStorage.permission)
            this.canEdit    = permissions.can_edit_formula_detail
        },
    }
</script>